export const profile = {
  fullName: 'Sergey Yudin',
  shortName: 'Serge Yudin',
  role: 'Senior Backend & Frontend Engineer',
  positioning: [
    'Senior Backend & Frontend Engineer',
    'Backend & Frontend Engineer',
    'Full-Stack Engineer',
  ],
  about:
    'Senior engineer with deep backend, frontend, architecture, and product delivery experience.',
  tagline:
    'I build and modernize production web applications for marketplaces, CRM systems, e-commerce, internal tools, and product teams.',
  specialization:
    'Node.js/NestJS-heavy backend, strong React/Vue frontend, architecture reviews, and delivery planning.',
  availability:
    'Open to full-time, contract, advisory, part-time, hourly, and project-based work.',
  phone: '+7 (938) 1426610',
  email: 'advictoriam2010@protonmail.com',
  experienceYears: '16+ years',
};

export const proofItems = [
  {
    metric: 'Freelance record',
    details: '16+ years in web development, Top Rated Plus, 100% Job Success Score',
  },
  {
    metric: 'Product delivery',
    details:
      'Delivered production systems for e-commerce, booking, CRM, marketplaces, and internal business tools.',
  },
  {
    metric: 'Scale experience',
    details: 'Worked on high-load web systems, infrastructure, performance tuning, and reliability improvements.',
  },
  {
    metric: 'Performance',
    details: 'Improved PageSpeed and runtime performance through server-side, frontend, and caching work.',
  },
  {
    metric: 'Open source',
    details: 'Selected accepted PRs in NestJS and Tailwind CSS, with links to the changes below.',
  },
];

export const links = [
  { label: 'Live site', url: 'https://yudin-s.github.io/' },
  { label: 'GitHub', url: 'https://github.com/yudin-s' },
  { label: 'Portfolio repository', url: 'https://github.com/yudin-s/yudin-s.github.io' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/sergeyudin/' },
  { label: 'Upwork', url: 'https://www.upwork.com/o/profiles/users/~011535c13b3445c54c/' },
  { label: 'Twitter/X', url: 'https://twitter.com/serge_yudin_' },
  { label: 'Facebook', url: 'https://www.facebook.com/sergeblackbox' },
];

export const experience = [
  {
    period: 'Sep 2024 - Jun 2025',
    title: 'Chief Technology Officer — GGEM',
    engagement: 'Full-time leadership',
    details:
      'Led technology strategy, architecture, and software delivery while staying close to hands-on engineering decisions.',
  },
  {
    period: 'Aug 2023 - Sep 2024',
    title: 'Senior NodeJS Developer — GGEM',
    engagement: 'Full-time engineering',
    details:
      'Built and maintained backend services, GraphQL APIs, infrastructure workflows, and production monitoring.',
  },
  {
    period: 'Jun 2022 - Aug 2023',
    title: 'Senior FullStack Developer — Leroy Merlin',
    engagement: 'Full-time engineering',
    details:
      'Delivered backend and frontend product features for a large retail environment with production delivery standards.',
  },
  {
    period: 'Feb 2021 - Jun 2022',
    title: 'Senior JS FullStack Developer — DataArt',
    engagement: 'Outstaff',
    details:
      'Worked as an outstaff engineer on full-stack JavaScript projects, combining backend development, frontend implementation, and product engineering.',
  },
  {
    period: 'Oct 2021 - Sep 2022',
    title: 'Senior JS FullStack Developer — Codemotion Ninjas',
    engagement: 'Outstaff at Lineate',
    details:
      'Outstaffed at Lineate, contributing frontend and backend development, code reviews, technical interviews, and internal tooling.',
  },
  {
    period: 'May 2019 - Apr 2020',
    title: 'Chief Technology Officer — Xrom Consulting Group',
    engagement: 'Leadership / client delivery',
    details:
      'Managed technical delivery, project planning, commerce development, and implementation decisions for client projects.',
  },
  {
    period: '2016 - Present',
    title: 'Upwork Freelance Full-Stack Developer',
    engagement: 'Parallel freelance / contract',
    details:
      'Top Rated Plus freelancer delivering backend, frontend, CRM, booking, marketplace, and e-commerce projects for remote clients.',
  },
  {
    period: '2017 - 2019',
    title: 'Chief Executive Officer — Blackbox Studio',
    engagement: 'Own studio',
    details:
      'Led client work, business analysis, negotiations, product planning, and senior-level software development.',
  },
  {
    period: '2016 - 2017',
    title: 'Chief Technology Officer — BlackBox Studio',
    engagement: 'Own studio',
    details: 'Led technical analysis, architecture planning, project management, and delivery process improvements.',
  },
  {
    period: '2014 - 2016',
    title: 'Senior PHP Programmer — BlackBox Studio',
    engagement: 'Full-time engineering',
    details:
      'Developed LAMP-based websites and commerce systems with PHP, CodeIgniter, CakePHP, Magento, and related tools.',
  },
  {
    period: 'Aug 2018 - Jan 2019',
    title: 'Director of Corporate Technology & Infrastructure — Noxster',
    engagement: 'Contract / leadership',
    details:
      'Built nine concurrent projects across three frameworks, with development risk management, technical writing, architecture, and hands-on development.',
  },
  {
    period: '2013 - Feb 2014',
    title: 'PHP Middle Developer — armor.mobi',
    engagement: 'Full-time engineering',
    details:
      'Designed architecture for a mobile-browser MMORPG, configured Apache, Nginx, Memcache, PHP 5.3, and ran high-load tests.',
  },
  {
    period: 'Aug 2012 - Jan 2013',
    title: 'Java Developer — Freelance',
    engagement: 'Freelance',
    details: 'Created a client-server Java RESTful application with SWT and an HTMLUnit-based bot.',
  },
  {
    period: '2010 - Oct 2012',
    title: 'PHP Junior Developer — CheckLinks',
    engagement: 'Early career',
    details: 'Developed modules for Drupal 6 and early web products.',
  },
];

export const education = [
  {
    period: '2011 - 2015',
    degree: "Bachelor's Degree in Software Engineering",
    institution:
      'Donetsk Technical University. GPA 4.5; led the programming contest team and reached final stages of All-Ukrainian sport programming competitions.',
  },
  {
    period: '2009 - 2011',
    degree: 'Zaporizhskiy Technical Lyceum',
    institution: 'National-level technical high school with math, physics, and programming specialization.',
  },
];

export const projects = [
  {
    name: 'Launchpack',
    description:
      'Small launch planning tool for turning rough product notes into positioning, assets, and release checklists.',
    category: 'Product / maker tool',
    liveUrl: 'https://yudin-s.github.io/launchpack/',
    repoUrl: 'https://github.com/yudin-s/launchpack',
    status: 'Side project',
  },
  {
    name: 'PullScope',
    description:
      'Browser-based pull request analysis tool for reviewing public GitHub PRs and spotting risk before merge.',
    category: 'Developer tool',
    liveUrl: 'https://yudin-s.github.io/pullscope/',
    repoUrl: 'https://github.com/yudin-s/pullscope',
    status: 'New project',
  },
  {
    name: 'Lobster',
    description:
      'Local automation system with multi-agent orchestration, Docker isolation, persistent memory, and context recovery.',
    category: 'Local engineering tool',
    repoUrl: 'https://github.com/yudin-s/lobster',
  },
  {
    name: 'Uncle Ben',
    description:
      'Local macOS voice assistant with wake-word activation, speech recognition, local intent parsing, and guarded actions.',
    category: 'Local engineering tool',
    repoUrl: 'https://github.com/yudin-s/uncle-ben',
  },
];

export const commercialProjects = [
  {
    name: 'GPS / GeoIP dealership CRM',
    description:
      'CRM with GeoIP dealer lookup, regional access rules, and custom landing pages.',
    category: 'CRM / web app',
    image: '/images/portfolio-01.png',
    tags: ['Backend', 'Frontend', 'CMS modernization'],
  },
  {
    name: 'At-Stamman booking admin panel',
    description:
      'Laravel admin panel for bookings, reporting, PDF/Excel exports, and large-data workflows.',
    category: 'Booking platform',
    image: '/images/portfolio-02.png',
    tags: ['Backend', 'Reporting', 'Admin UI'],
  },
  {
    name: 'GetEnergo marketplace',
    description: 'Marketplace frontend built from Figma with responsive UI and API integration.',
    category: 'Marketplace',
    image: '/images/portfolio-03.png',
    tags: ['Frontend', 'API integration', 'Responsive UI'],
  },
  {
    name: 'MyVoiceCloud audio startup',
    description:
      'Browser audio recording SaaS with microphone streaming, Laravel, Node.js, and database design.',
    category: 'SaaS / audio',
    image: '/images/portfolio-04.png',
    tags: ['SaaS', 'Backend', 'Audio'],
  },
  {
    name: 'At-Stamman online booking platform',
    description:
      'High-load medical booking platform delivered under a tight deadline with Wix login integration.',
    category: 'Booking platform',
    image: '/images/portfolio-05.png',
    tags: ['Backend', 'High-load', 'Integration'],
  },
  {
    name: 'Signlabs sticker e-commerce',
    description:
      'Sticker and decal designLab e-commerce platform with ordering, tracking, and long-term support.',
    category: 'E-commerce',
    image: '/images/portfolio-06.png',
    tags: ['E-commerce', 'Backend', 'Support'],
  },
  {
    name: 'GarmentDecor frontend',
    description:
      'Magento 1.9 storefront redesign implemented with Pug, HTML/CSS, and responsive frontend work.',
    category: 'Frontend / e-commerce',
    image: '/images/portfolio-07.png',
    tags: ['Frontend', 'Magento', 'Responsive UI'],
  },
  {
    name: 'VisualVision document platform',
    description:
      'Document review and editing platform with PDF review server, IDML support, and role management.',
    category: 'Document workflow',
    image: '/images/portfolio-08.png',
    tags: ['Web app', 'Backend', 'Role management'],
  },
  {
    name: 'Omron DeltaTau corporate site',
    description:
      'Drupal 7 corporate website rebuild with catalog, search, and content management modules.',
    category: 'CMS modernization',
    image: '/images/portfolio-09.png',
    tags: ['CMS', 'Search', 'Catalog'],
  },
  {
    name: 'At-Stamman event booking platform',
    description:
      'Laravel booking system for medical events with backend, responsive UI, and high-load readiness.',
    category: 'Booking platform',
    image: '/images/portfolio-10.png',
    tags: ['Backend', 'Frontend', 'High-load'],
  },
  {
    name: 'Ronix wakeboards store',
    description:
      'Magento store upgrade from 1.8 to 1.9.3 with security patches and release support.',
    category: 'E-commerce',
    image: '/images/portfolio-11.png',
    tags: ['Magento', 'Security', 'Release support'],
  },
  {
    name: 'Silk & Beach e-commerce',
    description: 'Magento-based e-commerce project with storefront implementation and production support.',
    category: 'E-commerce',
    image: '/images/portfolio-12.png',
    tags: ['Magento', 'Frontend', 'Production support'],
  },
  {
    name: 'Laravel e-commerce recovery',
    description:
      'Laravel e-commerce rescue: bug fixing, feature delivery, and stabilization after poor handoff.',
    category: 'E-commerce recovery',
    image: '/images/portfolio-13.png',
    tags: ['Laravel', 'Stabilization', 'Feature delivery'],
  },
  {
    name: 'CakePHP component development',
    description:
      'CakePHP components for infinite scroll, video uploading, and social-media processing workflows.',
    category: 'CMS & legacy',
    image: '/images/portfolio-14.png',
    tags: ['CakePHP', 'Backend', 'Components'],
  },
];

export const skills = {
  capabilities: [
    'Backend & Frontend',
    'Architecture & code review',
    'Product delivery',
    'Performance & reliability',
    'Legacy modernization',
    'Local tooling',
  ],
  frontend: [
    'React',
    'Vue',
    'Nuxt',
    'Next.js',
    'TypeScript',
    'JavaScript',
    'Material UI',
    'Redux',
    'styled-components',
    'HTML',
    'CSS',
    'Sass',
  ],
  backend: ['Node.js', 'NestJS', 'Express', 'Python', 'PHP', 'Java', 'REST', 'GraphQL', 'Laravel'],
  databases: ['MySQL', 'MariaDB', 'PostgreSQL', 'MongoDB', 'Redis', 'Oracle'],
  devops: [
    'AWS',
    'Docker',
    'Kubernetes',
    'Grafana',
    'GitHub Actions',
    'Linux',
    'CI/CD',
    'Nginx',
    'Apache',
  ],
  localTooling: [
    'LLM agents',
    'Ollama',
    'local AI tools',
    'voice assistants',
    'orchestration systems',
    'TensorFlow',
  ],
  domains: [
    'SaaS',
    'e-commerce',
    'marketplaces',
    'CRM',
    'booking platforms',
    'AdTech dashboards',
    'fintech',
    'blockchain',
    'startup products',
  ],
  seniorSignals: [
    'architecture',
    'code reviews',
    'delivery planning',
    'performance tuning',
    'legacy modernization',
  ],
};

export const openSource = [
  {
    repository: 'nestjs/nest',
    pullRequest: '#16948',
    commitMessage: 'fix(core): settle skipped provider initialization',
    commitAuthor: 'yudin-s',
    commitDate: 'Merged May 14, 2026',
    pullRequestUrl: 'https://github.com/nestjs/nest/pull/16948',
  },
  {
    repository: 'nestjs/nest',
    pullRequest: '#16945',
    commitMessage: 'feat(microservices): add grpc exception filter',
    commitAuthor: 'yudin-s',
    commitDate: 'Merged May 13, 2026',
    pullRequestUrl: 'https://github.com/nestjs/nest/pull/16945',
  },
  {
    repository: 'nestjs/nest',
    pullRequest: '#16943',
    commitMessage: 'fix(microservices): support regex Kafka patterns',
    commitAuthor: 'yudin-s',
    commitDate: 'Merged May 13, 2026',
    pullRequestUrl: 'https://github.com/nestjs/nest/pull/16943',
  },
  {
    repository: 'tailwindlabs/tailwindcss',
    pullRequest: '#20052',
    commitMessage: 'Fix canonicalize crash with plugin component values (#20052)',
    commitAuthor: 'yudin-s + Robin Malfait',
    commitDate: 'Merged May 14, 2026',
    pullRequestUrl: 'https://github.com/tailwindlabs/tailwindcss/pull/20052',
  },
];

export const productHunt = {
  profile: 'https://www.producthunt.com/@sergeyudin',
  role: 'Senior Backend & Frontend Engineer',
  about:
    'Maker profile for small side projects and product experiments.',
  keywords: ['web apps', 'developer tools', 'product workflows', 'real problems'],
  badge: 'Tastemaker',
  launches: [
    {
      name: 'Launchpack',
      status: 'Side project',
      url: 'https://www.producthunt.com/@sergeyudin',
    },
  ],
};
